import script from "./UserAdminActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAdminActions.vue?vue&type=script&setup=true&lang=ts"

import "./UserAdminActions.vue?vue&type=style&index=0&id=cffbd7b4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cffbd7b4"]])

export default __exports__